'use client';

import { createContext, useCallback, useContext, useState } from 'react';

import { useTranslation } from 'react-i18next';

interface NavigationBlockerContextType {
  isBlocked: boolean;
  setIsBlocked: (isBlocked: boolean) => void;
  promptWaitForUnsavedChanges: () => boolean;
}

export const NavigationBlockerContext =
  createContext<NavigationBlockerContextType>({
    isBlocked: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsBlocked: () => {},
    promptWaitForUnsavedChanges: () => false,
  });

export function NavigationBlockerProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  const [isBlocked, setIsBlocked] = useState(false);

  const promptWaitForUnsavedChanges = useCallback(() => {
    console.log(
      'promptWaitForUnsavedChanges',
      t('common:unsavedChangesConfirmation'),
    );
    if (isBlocked) {
      return !window.confirm(t('common:unsavedChangesConfirmation'));
    }
    return false;
  }, [isBlocked, t]);

  return (
    <NavigationBlockerContext.Provider
      value={{
        isBlocked,
        setIsBlocked,
        promptWaitForUnsavedChanges,
      }}
    >
      {children}
    </NavigationBlockerContext.Provider>
  );
}

export function useNavigationBlocker() {
  return useContext(NavigationBlockerContext);
}
